import React from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import './MissionTabs.css';

const MissionTabs = ({ activeTab, setActiveTab, viewerType = 'entreprise' }) => {
  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box className="mission-tabs-wrapper">
      <Tabs
        value={activeTab}
        onChange={handleChange}
        className="custom-tabs"
        TabIndicatorProps={{ className: 'tab-indicator' }}
      >
        <Tab label="La mission" value="mission" className="custom-tab" />
        <Tab label="Profil Recherché" value="profil" className="custom-tab" />
        <Tab label="Candidatures" value="infos" className="custom-tab" />
        {viewerType === 'entreprise' && (
          <Tab label="Historique" value="historique" className="custom-tab" />
        )}
      </Tabs>
    </Box>
  );
};

export default MissionTabs;
